export default "__VITE_ASSET__BoHz5UEz__"